module.exports = __webpack_public_path__ + "img/Stemness-BRCA_10X_DCIS.6da9abf4.png";